import * as firebase from 'firebase/app'

import { auth, db } from '../config/firebase'

export const addCharacter = async (campaignId, data) => {
  console.log('[addCharacter] User', auth.currentUser.uid, 'is adding character for campaignId', campaignId)
  console.log('[addCharacter] Data:', data)
  const owner = auth.currentUser.uid
  const payload = {
    details: data,
    owner,
    created: firebase.firestore.FieldValue.serverTimestamp()
  }

  const charRef = await db.collection('campaigns').doc(campaignId).collection('characters').doc(owner).set(payload)

  console.log('[addCharacter] Created character for campaignId', campaignId)

  return charRef
}

export const updateCharacter = async (campaignId, characterId, data) => {
  console.log('[updateCharacter] User', auth.currentUser.uid, 'is updating character', characterId, 'for campaignId', campaignId)
  console.log('[updateCharacter] Data:', data)

  return await db.collection('campaigns').doc(campaignId).collection('characters').doc(characterId).set({
    details: data,
    updated: firebase.firestore.FieldValue.serverTimestamp()
  }, { merge: true })
}

export const deleteCharacter = async (campaignId, characterId) => {
  console.log('[deleteCharacter] Deleting character for campaignId', campaignId, ':', characterId)

  const charRef = await db.collection('campaigns').doc(campaignId).collection('characters').doc(characterId).delete()

  console.log('[deleteCharacter] Deleted character for campaignId', campaignId, ':', characterId)

  return charRef
}

export const updateCareerSkill = async (campaignId, characterId, newCareerList) => {
  console.log('[updateCharacter] User', auth.currentUser.uid, 'is updating character', characterId, 'for campaignId', campaignId)
  console.log('[updateCharacter] updating career list:', newCareerList)
  return await db.collection('campaigns').doc(campaignId).collection('characters').doc(characterId).set({
    careerList: newCareerList,
    updated: firebase.firestore.FieldValue.serverTimestamp()
  }, { merge: true })
}

export const updateSkillRanks = async (campaignId, characterId, newSkillRanks) => {
  console.log('[updateCharacter] User', auth.currentUser.uid, 'is updating character', characterId, 'for campaignId', campaignId)
  console.log('[updateCharacter] updating skillRanks:', newSkillRanks)
  return await db.collection('campaigns').doc(campaignId).collection('characters').doc(characterId).set({
    skillRanks: newSkillRanks,
    updated: firebase.firestore.FieldValue.serverTimestamp()
  }, { merge: true })
}